import DelegationsReview from '../components/Accordion/components/DelegationsReview';
import SupportAndContactReview from '../components/Accordion/components/SupportAndContactReview';
import VideoTrainingReview from '../components/Accordion/components/VideoTrainingReview';

export const WIZARD_CODES = {
  ONBOARDING: 'onboarding'
};

export const WIZARD_PROGRESS = {
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  CONFIRMED: 'Confirmed',
  FAILED: 'Failed',
  INCOMPLETE: 'Incomplete'
};

export const STEP_STATE = {
  EXPANDED: 'expanded',
  COLLAPSED: 'collapsed'
};

export const SUBSTEP_STATE = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

/** JS breakpoint (px) for narrow vs wide layout. Below this width, sidebar becomes overlay. */
export const NARROW_SCREEN_BREAKPOINT = 1056;

/** Delay (ms) after intro "Next" before clearing entering-from-intro animation state. */
export const INTRO_ANIMATION_DURATION_MS = 980;

/** Delay (ms) before applying header compact animation after scroll state change. */
export const HEADER_ANIMATION_DELAY_MS = 10;

/**
 * Approximate px the header reclaims when collapsing to compact. Short pages
 * need this guard so compacting the header does not remove overflow and cause
 * the scroll state to bounce between expanded and collapsed.
 */
export const HEADER_COMPACT_RESERVE_PX = 120;

export const DEFAULT_BASE_URL_SEGMENTS = ['onboarding'];

export const SMART_SUGGESTIONS_DEFAULT_TITLE = 'MYRIAD SMART SUGGESTIONS';

export const INTRO_STEP_DEFAULT_DEFINITION = {
  step_id: 0,
  code: 'onboarding__intro',
  name: 'Intro',
  description: 'Welcome to Myriad Motion',
  is_required: false,
  order: 0,
  status: WIZARD_PROGRESS.INCOMPLETE,
  substeps: [
    {
      substep_id: 0,
      code: 'onboarding__intro__intro',
      name: 'Welcome to Myriad Motion',
      is_required: false,
      order: 1,
      description: 'Introduction to the Myriad Motion onboarding experience'
    }
  ]
};

export const REVIEW_STEP_DEFAULT_DEFINITION = {
  step_id: 999,
  code: 'onboarding__review',
  name: 'Review',
  description: 'Final review of your onboarding process',
  is_required: false,
  order: 14,
  status: WIZARD_PROGRESS.INCOMPLETE,
  substeps: [
    {
      substep_id: 9999,
      code: 'onboarding__review_review',
      name: 'Review',
      is_required: false,
      order: 1,
      description: 'Final review of your onboarding process'
    }
  ]
};

export const CUSTOM_REVIEW_COMPONENTS = {
  onboarding__support_and_contact: SupportAndContactReview,
  onboarding__delegation: DelegationsReview,
  onboarding__kickoff_video_training: VideoTrainingReview,
  onboarding__front_office_video_training: VideoTrainingReview,
  onboarding__back_office_video_training: VideoTrainingReview,
  onboarding__clinical_video_training: VideoTrainingReview,
  onboarding__hard_launch_video_training: VideoTrainingReview
};

export const IMPORT_FROM_ORG_CODE = 'onboarding__data_import__organization';

export const COMPLETED_STATUSES = [WIZARD_PROGRESS.COMPLETED, WIZARD_PROGRESS.CONFIRMED];

export const VIDEO_TRAINING_SUBSTEP_CODES = [
  'onboarding__hard_launch_video_training__hard_launch_video_training',
  'onboarding__back_office_video_training__back_office_video_training',
  'onboarding__clinical_video_training__clinical_video_training',
  'onboarding__kickoff_video_training__kickoff_video_training',
  'onboarding__front_office_video_training__front_office_video_training'
];

export const ONBOARDING_TOUR_COMPLETED_KEY = 'onboarding_tour_completed';

export const DATA_SECURITY_SMART_SUGGESTIONS = [
  {
    title: 'YOUR DATA IS SECURE',
    body: 'All your information is encrypted and HIPAA compliant, keeping your privacy protected.'
  }
];
